import Vue from 'vue'
import Vuex from 'vuex'
import * as firebase from 'firebase'
import moment from 'moment'
Vue.use(Vuex)

export const store = new Vuex.Store({
  state: {
    weeks: null,
    reports: null,
    loading: false,
    reportProcessing: false
  },
  mutations: {
    setReports (state, payload) {
      state.reports = payload
    },
    setLoading (state, payload) {
      state.loading = payload
    },
    setReportProcessing (state, payload) {
      state.reportProcessing = payload
    },
    setReport (state, payload) {
      const index = state.reports.findIndex(r => r.id === payload.id)
      state.reports[index] = payload
    }
  },
  actions: {
    loadReports ({commit}) {
      commit('setLoading', true)
      firebase.database().ref('reports').once('value')
      .then((data) => {
        const reports = []
        const obj = data.val()
        for (let key in obj) {
          reports.push({
            ...obj[key],
            id: key
          })
        }
        commit('setReports', reports)
        commit('setLoading', false)
      })
      .catch(
        (error) => {
          console.log(error)
          commit('setLoading', false)
        }
        )
    },
    loadReportsBydate ({commit}, payload) {
      commit('setLoading', true)
      firebase.database().ref('reports').once('value')
      .then((data) => {
        const reports = []
        const obj = data.val()
        for (let key in obj) {
          if (parseInt(moment.unix(obj[key].intervention.start_date_stamp).format('DD')) === payload[0] && parseInt(moment.unix(obj[key].intervention.start_date_stamp).format('MM')) === payload[1] && parseInt(moment.unix(obj[key].intervention.start_date_stamp).format('Y')) === payload[2]) {
            reports.push({
              ...obj[key],
              id: key
            })
          }
        }
        commit('setReports', reports)
        commit('setLoading', false)
      })
      .catch(
        (error) => {
          console.log(error)
          commit('setLoading', false)
        }
        )
    },
    saveReport ({commit}, payload) {
      commit('setReportProcessing', true)
      return new Promise((resolve, reject) => {
        firebase.database().ref('reports').set({
          [payload.id]: payload
        }).then((data) => {
          commit('setReport', payload)
          commit('setReportProcessing', false)
          resolve()
        }).catch((error) => {
          console.log(error)
          commit('setReportProcessing', false)
        })
      })
    }
  },
  getters: {
    getReports (state) {
      return state.reports
    },
    getReport (state) {
      return (id) => {
        return state.reports.find((item) => {
          return item.id === id
        })
      }
    },
    getReportByDate (state) {
      return (dates) => {
        return state.reports.filter((item) => {
          return moment.unix(item.intervention.start_date_stamp).isoWeek() === dates[0] && moment.unix(item.intervention.start_date_stamp).date() === dates[1]
        })
      }
    },
    loading (state) {
      return state.loading
    },
    reportProcessing (state) {
      return state.reportProcessing
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js